export default "__VITE_ASSET__3EUI6U8p__"